// extracted by mini-css-extract-plugin
export var caption = "Caption-module--caption--129c9";
export var captionResponsive = "Caption-module--caption-responsive--956cb";
export var cdsAssistiveText = "Caption-module--cds--assistive-text--842b0";
export var cdsVisuallyHidden = "Caption-module--cds--visually-hidden--94463";
export var hideFeedback = "Caption-module--hide-feedback--73d1e";
export var showFeedback = "Caption-module--show-feedback--776c7";
export var skeleton = "Caption-module--skeleton--d52e4";